import { render, staticRenderFns } from "./VideoPlayerFullscreen.vue?vue&type=template&id=10bc0356&scoped=true&"
import script from "./VideoPlayerFullscreen.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerFullscreen.vue?vue&type=style&index=0&id=10bc0356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc0356",
  null
  
)

export default component.exports